import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';

const Image = styled(Img)`
  width: 150px;
  margin-bottom: 40px;
`;

export default function Logo({ source }) {
  const { isMobile } = React.useContext(ThemeContext);

  if (isMobile) {
    return null;
  }

  return <Image alt="Livewire" src={source} />;
}

Logo.propTypes = {
  source: PropTypes.string.isRequired,
};
